import { StringLimiter } from './../../../common/helpers/string-limiter';
import { Component, OnInit, AfterViewInit, HostListener, Output, EventEmitter, Input, SimpleChanges, NgZone, inject } from '@angular/core';
import { TreeEditorApiService } from '../services/treeeditorapi.service';
import { V10ApiService } from 'src/app/services/v10-api.service';
import { IndividualBaseViewModel } from 'src/app/common/models/IndividualViewModel';
import { ResponseModel } from 'src/app/common/models/ResponseModel';
import { SessionData } from 'src/app/common/models/SessionData';
import { ParentNodeService } from '../services/parent-node.service';
import { ParentCommunicatorService } from 'src/app/services/parent-communicator.service';
import { ParentMessageType } from 'src/app/common/models/ParentMessage';
import { LoadingService } from 'src/app/services/UI/loading.service';
import { GuidGenerator } from 'src/app/common/helpers/guid-generator';
import { finalize, from, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { RelationShipType, EditorMode } from 'src/app/common/enums/enums';
import { MessageDialogService } from '../../common/message-dialog/services/message-dialog.service';
import { TranslateHandler } from 'src/app/common/helpers/translate-handler';
import { IndividualApiService } from 'src/app/services/API/individual-api.service';
import { IndividualRequestModel } from 'src/app/common/models/individual/individual-request-model';
import { CustomError } from 'src/app/common/helpers/custom-error';
import { ComponentBase } from '../../common/base/component-base';
import { RootMember } from '../../../common/models/RootMember';
import { NotifierEvents } from '../../../common/enums/enums';
import { NotifierV2Service } from 'src/app/services/notifier-v2.service';
import { ApiBaseService } from 'src/app/services/api-base.service';
import { IndividualIdbService  } from 'src/app/services/IndexedDb/individual-idb.service';
import { ProjectIdbService } from 'src/app/services/IndexedDb/project-idb.service';
import { RootMemberMapper } from 'src/app/common/mappers/RootMemberMapper';
import { wheelExpandAnim, wheelBackdropAnim } from 'src/app/shared/animations/animations';

@Component({
    selector: 'app-treeeditorview',
    templateUrl: './treeeditorview.component.html',
    styleUrls: ['./treeeditorview.component.scss'],
    standalone: false,
    animations: [wheelExpandAnim, wheelBackdropAnim]
})
export class TreeeditorviewComponent extends ComponentBase implements OnInit, AfterViewInit {
  fixedLabels: any[] = [];
  repeatTimes = [0, 1, 2, 3];
  limitLength: number = 21;
  pedegreeData: IndividualBaseViewModel[];
  rootMemberId: number = 1;
  parentObj: SessionData;
  showView: boolean = false;
  expandColor: any = "#f4f9e7";
  subscriptionRootMemberId: any;
  isExpandingWheelOn: boolean = false;
  selectedmemberDetail: any;
  @Input() editedLabelImage: any;
  @Output() public isExpandingWheelActive = new EventEmitter<boolean>();

  //Position control variables for ipad View
  treeEditorXMove: number = 0;
  treeEditorYMove: number = 0;
  switchToIpadView: boolean = false;
  defaultScale: number = 1;
  viewScale: number = 1;
  deviceWidth: number = 0;
  deviceHeight: number = 0;
  tabDevicesWidthLimit = 1025;
  mobileDevicesWidthLimit = 810;
  isMobileDevice: boolean = false;
  individualmanagementSubscription: Subscription;
  pedigreeSubscription: Subscription;
  treeEditorReloadSubscription = new Subscription();
  sessionDataSubcriber = new Subscription();
  numberOfMembersAddedBeforeFresh: number = 0;
  loaderTimeout = environment.RELOAD_FREQUENCE;
  rootMember: any;
  allRelationsLoaded: boolean = false;
  renderLabels: any[] = [];
  timeTag: string;
  @Output() public showMain: EventEmitter<boolean> = new EventEmitter<boolean>();
  componentName = 'TreeEditor';
  expectedUpdates = [ NotifierEvents.RootMemberChanged,
                      NotifierEvents.RootFamilyUpdated,
                      NotifierEvents.EditorModeChanged
                    ];
  content: any;

  // state
  animationPhase: 'idle' | 'highlight' | 'travelToRoot' | 'release' = 'idle';
  selectedNodeId: number | null = null;
  isTransitioning: boolean = false;
  finishedRootNodeId: number | null = null;

  highlightTime: number = 700;
  travelTimeLeveL0: number = 1500;
  travelTimeLeveL1: number = 1500;
  travelTimeLeveL2: number = 1500;
  travelTimeLeveL3: number = 1800;
  travelTimeLeveL4: number = 2000;
  travelTimeLeveL5: number = 2800;

  travelNodeId: number | null = null;

  private highlightTimeoutId: any = null;
  private travelTimeoutId: any = null;
  private releaseTimeoutId: any = null;

  // Photo-circle center offset (relative to the node's own translate(label.x,label.y) origin)
  // and radius, in tree-canvas units. Root carries the node-level translate(-80,-10) scale(0.6);
  // parents/grandparents share the plain scale(0.47) — see mainlabels' circle pivot (122.6,90.5).
  private readonly WHEEL_LIGHT_RED = '#F3B4B4';
  private readonly WHEEL_LIGHT_BLUE = '#AFD3F2';

  private wheelGeometry(label: any): { cx: number; cy: number; r0: number; r1: number } {
    const isRoot = label.displayIndex === 0;
    const isParent = label.displayIndex === 1 || label.displayIndex === 1.01;
    const offset = isRoot ? { x: -6.4, y: 44.3 } : { x: 57.6, y: 42.5 };
    const photoR = isRoot ? 73.9 : isParent ? 48.3 : 37.1;
    const pcx = label.x + offset.x;
    const pcy = label.y + offset.y;
    const wheelScale = 0.88;
    const baseR0 = photoR + 14;
    const r0 = baseR0 * wheelScale;
    const r1 = (baseR0 + Math.max(90, baseR0 * 1.6)) * wheelScale;
    const rOuter = r1 + 13;

    // Clamp against the real browser window, not just this canvas's own rect — the wheel
    // is allowed to overlay the left panel/top menu (via the fixed overlay's z-index), it
    // just shouldn't run off the physical edge of the screen. Convert viewBox <-> screen
    // pixels using the tracked rect of #svg-content, matching how preserveAspectRatio
    // "xMidYMid meet" actually letterboxes it.
    // Only root (left edge) and the topmost grandparent (top edge, displayIndex 2) are
    // ever close enough to a screen edge to need this — every other node's wheel stays
    // exactly centered on its own photo, unclamped.
    let cx = pcx, cy = pcy;
    const needsClamp = isRoot || label.displayIndex === 2;
    const rect = this.rootRect;
    if (needsClamp && rect && rect.width && rect.height) {
      const vb = { x0: 0, y0: 160, w: 2150, h: 560 };
      const scale = Math.min(rect.width / vb.w, rect.height / vb.h);
      const rw = vb.w * scale, rh = vb.h * scale;
      const offX = rect.left + (rect.width - rw) / 2;
      const offY = rect.top + (rect.height - rh) / 2;
      const toScreenX = (vx: number) => offX + (vx - vb.x0) * scale;
      const toScreenY = (vy: number) => offY + (vy - vb.y0) * scale;
      const toViewX = (sx: number) => (sx - offX) / scale + vb.x0;
      const toViewY = (sy: number) => (sy - offY) / scale + vb.y0;
      const pad = 8;
      const rOuterPx = rOuter * scale;
      const winW = window.innerWidth, winH = window.innerHeight;
      const clamp = (v: number, lo: number, hi: number) => (lo > hi ? (lo + hi) / 2 : Math.min(Math.max(v, lo), hi));
      const sx = clamp(toScreenX(pcx), pad + rOuterPx, winW - pad - rOuterPx);
      const sy = clamp(toScreenY(pcy), pad + rOuterPx, winH - pad - rOuterPx);
      cx = toViewX(sx);
      cy = toViewY(sy);
    }
    return { cx, cy, r0, r1 };
  }

  // Pivot point for the wheel's enter/leave scale animation
  wheelCenterOrigin(label: any): string {
    const { cx, cy } = this.wheelGeometry(label);
    return `${cx}px ${cy}px`;
  }

  wheelRing(label: any): { cx: number; cy: number; rOuter: number; rAccent: number } {
    const { cx, cy, r1 } = this.wheelGeometry(label);
    return { cx, cy, rOuter: r1 + 13, rAccent: r1 + 4 };
  }

  trackBySectorLabel(index: number, sector: { labelKey: string }): string {
    return sector.labelKey;
  }

  wheelSectors(label: any): { d: string; fill: string; labelKey: string; lx: number; ly: number; onClick: () => void }[] {
    const { cx, cy, r0, r1 } = this.wheelGeometry(label);
    const spouseFill = label.gender === 'F' ? this.WHEEL_LIGHT_BLUE : this.WHEEL_LIGHT_RED;
    const defs = [
      { labelKey: 'lbl_sister', fill: this.WHEEL_LIGHT_RED, onClick: () => this.addSibling('Sister', label) },
      { labelKey: 'lbl_brother', fill: this.WHEEL_LIGHT_BLUE, onClick: () => this.addSibling('Brother', label) },
      { labelKey: 'lbl_spouse', fill: spouseFill, onClick: () => this.addSpouse(label) },
      { labelKey: 'lbl_son', fill: this.WHEEL_LIGHT_BLUE, onClick: () => this.addChild('Son', label) },
      { labelKey: 'lbl_daughter', fill: this.WHEEL_LIGHT_RED, onClick: () => this.addChild('Daughter', label) },
    ];
    const toRad = (d: number) => (d * Math.PI) / 180;
    return defs.map((def, i) => {
      const a0 = toRad(-90 + i * 72);
      const a1 = toRad(-90 + (i + 1) * 72);
      const am = (a0 + a1) / 2;
      const p1x = cx + r0 * Math.cos(a0), p1y = cy + r0 * Math.sin(a0);
      const p2x = cx + r1 * Math.cos(a0), p2y = cy + r1 * Math.sin(a0);
      const p3x = cx + r1 * Math.cos(a1), p3y = cy + r1 * Math.sin(a1);
      const p4x = cx + r0 * Math.cos(a1), p4y = cy + r0 * Math.sin(a1);
      const d = `M ${p1x} ${p1y} L ${p2x} ${p2y} A ${r1} ${r1} 0 0 1 ${p3x} ${p3y} L ${p4x} ${p4y} A ${r0} ${r0} 0 0 0 ${p1x} ${p1y} Z`;
      const labelR = (r0 + r1) / 2;
      return { d, fill: def.fill, labelKey: def.labelKey, onClick: def.onClick, lx: cx + labelR * Math.cos(am), ly: cy + labelR * Math.sin(am) };
    });
  }

  // timings
  private phaseDurations = {
    highlight: this.highlightTime,     // 1s glow + fade
    travelByLevel: {
      0: this.travelTimeLeveL0,  // levels 0-2 → 1.5s
      1: this.travelTimeLeveL1,
      2: this.travelTimeLeveL2,
      3: this.travelTimeLeveL3,  // level 3
      4: this.travelTimeLeveL4,  // level 4
      5: this.travelTimeLeveL5   // level 5
    }
  };

  // helpers
  isActive = (label: any) => {
    // During travel/transition, keep one stable "active" node
    if (this.travelNodeId !== null) {
      return this.travelNodeId === label.displayIndex;
    }
    return this.selectedNodeId === label.displayIndex;
  };
  shouldFade = (label: any) => !!this.selectedNodeId && this.selectedNodeId !== label.displayIndex;

  // Detect resolution changes
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.detectDeviceSizes();
    this.setTabView();
  }

  constructor (
    public v10restApi: V10ApiService,
    private treeEditorApiserive: TreeEditorApiService,
    public parentNodeService: ParentNodeService,
    public stringLimit: StringLimiter,
    private parentCommunicatorService: ParentCommunicatorService,
    private loadingService: LoadingService,
    private messageDialogSerivce: MessageDialogService,
    private translateHandler: TranslateHandler,
    private individualApiService: IndividualApiService,
    private apibaseservice : ApiBaseService,
    private individualDbService     : IndividualIdbService ,
    private projectDbService     : ProjectIdbService ,
    private rootMemberMapper: RootMemberMapper
  ) {
    super();
    this.fixedLabels = parentNodeService.parentlabelinfo;
    this.parentObj = new SessionData();
  }

  async getPedigreeInfo(isEnable?: boolean) {
    let processId = GuidGenerator.generate();
    if (!isEnable) {
      this.loadingService.show(processId);
    }

    if (environment.IS_INDEXED_DB_ENABLED) {
      var projectId = await this.projectDbService.getProject();
      const tableName = this.individualDbService.getTableName(projectId);
      this.pedigreeSubscription = from(this.individualDbService.getIndividuals(tableName, this.rootMember.Id))
        .subscribe({
          next: (response) => {
            if (response && response.length > 0) {
              this.numberOfMembersAddedBeforeFresh = 0;
              this.pedegreeData = response;
              this.generateLabels();
              // Fresh labels are in, so displayIndex === 0 already identifies the real root -
              // the finishedRootNodeId bridge (see isRootTier() in mainlabels) is no longer
              // needed and must not survive into the next refresh, or it'll wrongly oversize
              // whichever node inherits that stale displayIndex slot.
              this.finishedRootNodeId = null;
              // this.stringLimit.update();
            } else {
              console.warn('No pedigree data found.');
            }
          },
          error: (error) => {
            console.error('Error fetching pedigree data:', error);
          },
          complete: () => {
            this.loadingService.hide(processId);
          },
        });
    }
    else {
      this.pedigreeSubscription = this.treeEditorApiserive.getTreePedigree(this.rootMember.Id).pipe(
        finalize(() => {
          this.loadingService.hide(processId);
        })
      ).subscribe({
        next: (response: ResponseModel<IndividualBaseViewModel[]>) => {
          this.numberOfMembersAddedBeforeFresh = 0;
          this.pedegreeData = response.data;
          this.generateLabels();
          // See the IndexedDB branch above for why this must be cleared here, not on a timer.
          this.finishedRootNodeId = null;
          //this.stringLimit.update();
          this.loadingService.hide(processId);
          if (response) {
            this.allRelationsLoaded = true;
            this.selectedNodeId = null;
          }
        },
        error: (error) => {
          this.loadingService.hide(processId);
        }
      }
      );
    }
  }

  ngOnInit(): void {
    this.numberOfMembersAddedBeforeFresh = 0;
    let selectedMember = this.notifierService.getCurrentRootMemberId(true);

    // Note: This if is used to handle the situation where the angular 9 app is initially loaded and nothing is in the history list.
    // Todo: In the application start (second phase of revamp) this has to be handled in a proper manner.

    if(!selectedMember)
    {
      this.sessionDataSubcriber = this.apibaseservice.sessionDataSubject.subscribe((sessionData) => {
        if (sessionData) {
          let dataObj =  JSON.parse(sessionData);
          this.rootMember = {Id : dataObj.rootMemberId}
          this.getPedigreeInfo();
        }
      });
    }
    else {
      this.rootMember = { Id : this.notifierService.getCurrentRootMemberId()};
      this.getPedigreeInfo();
    }

    this.detectDeviceSizes();
  }


  // main sequence
  changeRootPerson(label: any) {
    if (this.isTransitioning) return;
    this.isTransitioning = true;

    // lock the travelling node id (stable, even if labels refresh)
    this.travelNodeId = label.displayIndex;

    this.selectedNodeId = label.displayIndex;
    this.finishedRootNodeId = null;
    this.animationPhase = 'highlight'; // just CSS glow/fade; no movement yet
    this.allRelationsLoaded = false;
    const levelIndex = Math.floor(label.displayIndex);

    this.highlightTimeoutId = setTimeout(() => {
      // Move from its own position to root, while scale animates 1 -> 1.6 -> 1
      this.animationPhase = 'travelToRoot';

      // choose duration based on level
      const travelTime =
        this.phaseDurations.travelByLevel[levelIndex] ??
        this.phaseDurations.travelByLevel[1]; // fallback

      this.travelTimeoutId = setTimeout(() => {
        // Now we are at root position and back to scale(1). Emit and clean up.
        this.finishedRootNodeId = label.displayIndex;

        // For level 4, map through rootMemberMapper before notify
        let rootMember;
        if (label.displayIndex === 3 || label.displayIndex === 4 || label.displayIndex === 5) {
          rootMember = this.rootMemberMapper.map(label);
        } else {
          rootMember = this.selectedRootMember(label);
        }

        this.notifierService.updateEvent(NotifierEvents.RootMemberChanged,  rootMember, true);


        this.animationPhase = 'release';

        this.releaseTimeoutId = setTimeout(() => {
          this.animationPhase = 'idle';
          this.isTransitioning = false;
        }, 100);

        this.travelNodeId = null; // release lock AFTER the small buffer
      }, travelTime);

    }, this.phaseDurations.highlight);

    // Set travel to root timing in scss
    const root = document.documentElement;
    switch (levelIndex) {
      case 3:
        root.style.setProperty("--t-travel-current", "var(--t-travel-l4)");
        break;
      case 4:
        root.style.setProperty("--t-travel-current", "var(--t-travel-l5)");
        break;
      case 5:
        root.style.setProperty("--t-travel-current", "var(--t-travel-l6)");
        break;
      default: // level 1-3
        root.style.setProperty("--t-travel-current", "var(--t-travel-l1-3)");
    }

  }

  // Build transform for each node wrapper
  nodeTransform(label: any): string {
    const base = { x: label.x, y: label.y };

    if (!this.isActive(label)) {
      // Others never move; they only fade
      return `translate(${base.x}, ${base.y})`;
    }

    if (this.animationPhase === 'travelToRoot' || this.animationPhase === 'release') {
      const r = this.getRootPos(label?.displayIndex);
      return `translate(${r.x}, ${r.y})`; // end position = root
    }

    if (this.finishedRootNodeId === label.displayIndex) {
      const r = this.getRootPos(label?.displayIndex);
      return `translate(${r.x}, ${r.y})`;
    }
    // highlight/release/idle: keep at its own position
    return `translate(${base.x}, ${base.y})`;
  }

  private getRootPos(indexLevel: number) {
    const root = this.renderLabels?.[0];
    // Align first 0-2 levels to the root
    if (indexLevel >= 0 && indexLevel < 3) {
      return root ? { x: root.x, y: root.y } : { x: 0, y: 0 };
    } else if (indexLevel >= 3) {
    // Align level 3+ to the root
      return root
        ? { x: root.x + 80, y: root.y + 30 }
        : { x: 80, y: 30 };
    }
    return root ? { x: root.x, y: root.y } : { x: 0, y: 0 };
  }

  // (unchanged) helpers you already have
  selectedRootMember(label: any) {
    return { Id: label.id, displayName: label.displayName };
  }


  private getOrderedLabels(start: number, end: number) {
    const arr = this.renderLabels.slice(start, end).reverse();
    if (this.selectedNodeId == null) return arr;

    const idx = arr.findIndex(l => l.displayIndex === this.selectedNodeId);
    if (idx > -1) {
      const [sel] = arr.splice(idx, 1);
      arr.push(sel); // render active last => on top
    }
    return arr;
  }

  orderedLabels() {
    return this.getOrderedLabels(0, 7);
  }

  orderedLabelsL4() {
    return this.getOrderedLabels(7, 15);
  }

  orderedLabelsL5() {
    return this.getOrderedLabels(15, 31);
  }

  orderedLabelsL6() {
    return this.getOrderedLabels(31,63);
  }

  detectDeviceSizes() {
    var svgMain = document.getElementById('svg-content'); // use host-element -> refactor => this.hostElement.nativeElement
    this.deviceWidth = svgMain.clientWidth;
    this.deviceHeight = svgMain.clientHeight;
  }

  // Tracks #svg-content's on-screen rect so the wheel overlay (rendered outside the
  // tree canvas's own stacking context) can align itself pixel-for-pixel over it.
  rootRect: { left: number; top: number; width: number; height: number } | null = null;
  private rootRectObserver: ResizeObserver;
  private zone = inject(NgZone);
  private updateRootRect = () => {
    const el = document.getElementById('svg-content');
    if (!el) return;
    const r = el.getBoundingClientRect();
    // ResizeObserver callbacks run outside Angular's zone (Zone.js doesn't patch it),
    // so re-enter the zone to make sure the overlayStyle() binding refreshes.
    this.zone.run(() => {
      this.rootRect = { left: r.left, top: r.top, width: r.width, height: r.height };
    });
  };

  ngAfterViewInit(): void {
    this.updateRootRect();
    const el = document.getElementById('svg-content');
    this.rootRectObserver = new ResizeObserver(this.updateRootRect);
    if (el) this.rootRectObserver.observe(el);
    window.addEventListener('resize', this.updateRootRect);
    window.addEventListener('scroll', this.updateRootRect, true);
  }

  // Positions the wheel-overlay SVG (position:fixed, z-index above the left panel/top menu)
  // to exactly match the tree canvas's rect, so the wheel renders on top of them when open.
  overlayStyle(): string {
    if (!this.rootRect) return 'display:none';
    const pointerEvents = this.isExpandingWheelOn ? 'auto' : 'none';
    return `position:absolute;left:${this.rootRect.left}px;top:${this.rootRect.top}px;width:${this.rootRect.width}px;height:${this.rootRect.height}px;overflow:visible;display:block;pointer-events:${pointerEvents}`;
  }

  // Expanding wheel functions
  expandWheel(content) {
    // Content is used to close the expand wheel when switching root member
    this.content = content;
    if(this.content.expanded)
      this.content = undefined;

    content.expanded = !content.expanded;
    this.isExpandingWheelOn = !this.isExpandingWheelOn;
    this.isExpandingWheelActive.emit(this.isExpandingWheelOn);
    if (content.expanded) {
      this.expandColor = "#7a7d74";
    } else {
      this.expandColor = "#f4f9e7";
    }
  }

  showFamily(renderLabelIndex) {
    let renderLabelByIndex = this.renderLabels[renderLabelIndex];
    if (renderLabelByIndex) {
      var immediateFamily = renderLabelByIndex.spouseFamilyId == 0 ? renderLabelByIndex.parentFamilyId : renderLabelByIndex.spouseFamilyId;
      let data = {
        id: immediateFamily,
        editorMode: EditorMode.FamilyEditor,
        individualId: renderLabelByIndex.parentFamilyId == 0 ? renderLabelByIndex.id : 0,
        family: {},
        isUpdateHistory: true
      }
      this.notifierService.updateEvent(NotifierEvents.RootFamilyChanged, data)
      this.notifierService.setCurrentEditor("/editor/familyeditor", data, null);
    }
  }

  notify()
  {
    // Content is used to close the expand wheel when switching root member
    if(this.content)
      this.expandWheel(this.content);
    this.rootMember = this.notifierService.getCurrentRootMember();
    // if(this.notifierService.componentName === EditorMode[EditorMode.TreeEditor])
    const isEnable = this.notifierService.getBooleanValue();
      this.getPedigreeInfo(isEnable);
  }

  show(data: any)
  {
    if(!this.rootMember)
    {
      this.rootMember = {Id : data.id} as RootMember
    }
    else {
      this.rootMember.Id = data.id;
    }
    this.showMain.emit(true);
  }

  hide()
  {
    this.showMain.emit(false);
  }

  //Open any editor
  openEditor(id: number, mode: EditorMode) {
    let data = {
      id: id,
      editorMode: mode,
      isUpdateHistory: true
    }
    this.notifierService.setCurrentEditor(`/editor/individualeditor`,  data, null);
  }

  addParent(memberData) {
    this.selectedmemberDetail = memberData.label;
    var gender = memberData.index % 2 == 0 ? "F" : "M";

    let title = this.translateHandler.translate(memberData.index % 2 == 0 ? 'lbl_mother_of' : 'lbl_father_of', [memberData.label.childDisplayName]);
    let subTitle = this.translateHandler.translate(memberData.index % 2 == 0 ? 'lbl_mothers_name' : 'lbl_fathers_name', [memberData.label.childDisplayName]);

    this.messageDialogSerivce.openIndividualDialog(title, subTitle, memberData.label.childId, 0, 1).subscribe((response: any) => {
      if (response) {
        var individualRequestModel = this.createIndividualRequestModel(gender, response.name, memberData.label.spouseFamilyId, memberData.label.childId, memberData.label.gender);
        this.createVirtualParentNode(individualRequestModel, response);
      }
    },
      (err) => {
        throw new CustomError("TreeeditorviewComponent => addParent() : " + err, 911, false)
      })
      .add();
  }

  createVirtualParentNode(individualRequestModel, response) {
    this.individualApiService.createParent(individualRequestModel).subscribe(async (member: any) => {
      if (member) {
        if (individualRequestModel.relatedMemberId == this.rootMember.Id) {
          this.rootMember.displayName = this.selectedmemberDetail.childDisplayName;
          await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
        }

        // this.numberOfMembersAddedBeforeFresh++;
        // if (this.numberOfMembersAddedBeforeFresh >= this.loaderTimeout) {
        //   this.numberOfMembersAddedBeforeFresh = 0;
          //Reload tree after given no of members added
          this.getPedigreeInfo();
        // }

        // NOTE: The following code is used when show and hide the tree editor
        // Todo: Have to remove this piece of code after confirming the reason and evaluating

        // let childLabelIndex = this.renderLabels.findIndex((obj => obj.id === Number(this.selectedmemberDetail.childId)));
        // this.renderLabels[childLabelIndex].parentFamilyId = member.data.spouseFamilyId;

        // let parentIndexes = this.renderLabels.filter((obj => obj.childId === Number(this.selectedmemberDetail.childId)));
        // parentIndexes.forEach(element => {
        //   element.spouseFamilyId = member.data.spouseFamilyId;
        // });

        // member.data.displayIndex = this.selectedmemberDetail.displayIndex;
        // member.data["fatherDisplayIndex"] = this.getDisplayIndex(this.selectedmemberDetail.displayIndex, 0.0);
        // member.data["motherDisplayIndex"] = this.getDisplayIndex(this.selectedmemberDetail.displayIndex, 0.1);
        // member.data["childId"] = this.selectedmemberDetail.childId;
        // //Adding Member
        // this.getNewRenderObject(member, member.data.displayIndex, false);
        // //Adding Mother
        // this.getNewRenderObject(member, member.data.motherDisplayIndex, true);
        // //Adding Father
        // this.getNewRenderObject(member, member.data.fatherDisplayIndex, true);
      }

      // Navigate to individual editor
      if(response.isMemberNavigate){
        await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, member.data);
        this.openEditor(member.data.id, EditorMode.IndividualEditor);
      }

      this.saveIndividual(member, "parent");
    });
  }

  addSibling(index, label) {
    this.expandWheel(label);
    var gender = index == 'Brother' ? "M" : "F";

    let title = this.translateHandler.translate(gender == 'M' ? 'lbl_brother_of' : 'lbl_sister_of', [label.displayName]);
    let subTitle = this.translateHandler.translate(gender == 'M' ? 'lbl_brothers_name' : 'lbl_sisters_name', [label.displayName]);

    this.messageDialogSerivce.openIndividualDialog(title, subTitle, label.childId, 0, 1).subscribe((response: any) => {
      if (response) {
        let individualRequestModel = new IndividualRequestModel();
        individualRequestModel = this.createIndividualRequestModel(gender, response.name, label.parentFamilyId, label.id, label.gender);
        this.individualApiService.createSibling(individualRequestModel).subscribe(async (sibling: any) => {
          if (label.id == this.rootMember.Id) {
            this.rootMember = { ...this.rootMember, displayName: label.displayName };
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
          }
          // Navigate to individual editor
          if(response.isMemberNavigate){
            const updatedSibling = {
              ...sibling.data,
              displayName: sibling?.data?.fullName
            };;
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, updatedSibling);
            this.openEditor(updatedSibling.id,EditorMode.IndividualEditor);
          }
          this.saveIndividual(sibling, "sibling");
        });
      }
    },
      (err) => {
        throw new CustomError("TreeeditorviewComponent => addSibling() : " + err, 911, false)
      })
      .add();
  }

  addChild(index, label) {
    this.expandWheel(label);
    var gender = index == 'Son' ? "M" : "F";
    let title = this.translateHandler.translate(gender == 'M' ? 'lbl_son_of' : 'lbl_daughter_of', [label.displayName]);
    let subTitle = this.translateHandler.translate(gender == 'M' ? 'lbl_sons_name' : 'lbl_daughters_name', [label.displayName]);

    this.messageDialogSerivce.openIndividualDialog(title, subTitle, label.spouseFamilyId, label.id, gender == 'M' ? RelationShipType.Son : RelationShipType.Daughter).subscribe((response: any) => {
      if (response) {
        let individualRequestModel = new IndividualRequestModel();
        individualRequestModel = this.createIndividualRequestModel(gender, response.name, response.familyId, label.id, label.gender);
        this.individualApiService.createChild(individualRequestModel).subscribe(async (child : any) => {
          if (label.id == this.rootMember.Id) {
            this.rootMember = { ...this.rootMember, displayName: label.displayName };
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
          }
          // Update Left Pannel for index 1
          if (label.id != this.rootMember.Id && label.displayIndex < 2) {
            if (!this.rootMember?.displayName) {
              this.rootMember = await this.notifierService.getCurrentRootMember();
            }
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
          }
          // Navigate to individual editor
          if(response.isMemberNavigate){
            const updatedChild = {
              ...child.data,
              displayName: child?.data?.fullName
            };
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, updatedChild);
            this.openEditor(updatedChild.id,EditorMode.IndividualEditor);
          }
          this.saveIndividual(child, "child");
        });
      }
    },
      (err) => {
        throw new CustomError("TreeeditorviewComponent => addChild() : " + err, 911, false)
      })
      .add();
  }

  addSpouse(label) {
    this.expandWheel(label);
    var gender = label.gender == 'M' ? "F" : "M";
    let title = this.translateHandler.translate('lbl_spouse_of', [label.displayName]);
    let subTitle = this.translateHandler.translate('lbl_spouses_name', [label.displayName]);

    this.messageDialogSerivce.openIndividualDialog(title, subTitle, label.spouseFamilyId, label.id, RelationShipType.Spouse).subscribe((response: any) => {
      if (response) {
        let individualRequestModel = new IndividualRequestModel();
        individualRequestModel = this.createIndividualRequestModel(gender, response.name, response.familyId, label.id, label.gender);
        this.individualApiService.createSpouse(individualRequestModel).subscribe(async (spouse : any) => {
          if (label.id == this.rootMember.Id) {
            this.rootMember = { ...this.rootMember, displayName: label.displayName };
            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
          }
           // Navigate to individual editor
          if (response.isMemberNavigate) {
            const updatedSpouse = {
              ...spouse.data,
              displayName: spouse?.data?.fullName
            };

            await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, updatedSpouse);
            this.openEditor(updatedSpouse.id, EditorMode.IndividualEditor);
          }
          this.saveIndividual(spouse, "spouse");
          if (response.familyId) {
            this.getPedigreeInfo();
            if(label.id != this.rootMember.Id && label.displayIndex < 2){
              await this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
            }
          }
        });
      }
    },
      (err) => {
        throw new CustomError("TreeeditorviewComponent => addSpouse() : " + err, 911, false)
      })
      .add();
  }

  private saveIndividual(individualResponse: any, type: string) {
    if (environment.IS_INDEXED_DB_ENABLED) {
      this.saveIndividualData(individualResponse, type)
        .then(() => {
          console.log(type, "data saved successfully in index DB");
        })
        .catch((error) => {
          console.error("Error while saving ", type , "data in index DB:", error);
        });
    }
  }

  async saveIndividualData(individualResponse: any, type:string) {
    var projectId = await this.projectDbService.getProject();
    const formattedIndividualData = this.formatIndividualData(individualResponse.data, projectId, type)
    try {
    const tableName = await this.individualDbService.getTableName(projectId);
      if (tableName != null) {
        await this.individualDbService.saveData(projectId, formattedIndividualData);
      }
    }
    catch (error) {
      console.error(`Error while saving individual in index DB:`, error);
    }
  }

  formatIndividualData(individualResponseData: any, projectId: any, type: string) {
    const baseData = {
      id: individualResponseData.id,
      projectId: projectId,
      gender: individualResponseData.gender,
      profileImageId: individualResponseData.profilePictureId,
      parentFamily: {
        husbandId: 0,
        wifeId: 0,
        id: 0
      }
    };

    if (type === "parent") {
      return {
        ...baseData,
        displayName: individualResponseData.displayName,
        fullName: individualResponseData.displayName,
        givenName: individualResponseData.displayName,
        links: ''
      };
    } else {
      return {
        ...baseData,
        displayName: `${individualResponseData.givenName ?? ''} ${individualResponseData.surname ?? ''}`.trim(),
        fullName: `${individualResponseData.givenName ?? ''} ${individualResponseData.surname ?? ''}`.trim(),
        givenName: individualResponseData.givenName,
        surName: individualResponseData.surname,
        links: individualResponseData.links,
      };
    }
  }

  //Create request object for individual create
  createIndividualRequestModel(gender: string, memberName: string, relatedFamilyId: number, relatedMemberId: number, relatedMemberGender: string = null) {
    let individualRequestModel = new IndividualRequestModel();
    individualRequestModel.gender = gender
    individualRequestModel.memberName = memberName;
    individualRequestModel.relatedFamilyId = relatedFamilyId;
    individualRequestModel.relatedMemberId = relatedMemberId;
    individualRequestModel.relatedMemberGender = relatedMemberGender;

    return individualRequestModel;
  }

  getNewRenderObject(member: any, displayIndex: Number, isParent: boolean) {
    let objIndex = this.renderLabels.findIndex((obj => obj.displayIndex === Number(displayIndex)));
    if (objIndex > -1) {
      if (isParent) {
        this.renderLabels[objIndex].childId = member.data.id;
        this.renderLabels[objIndex].status = "disable";
        this.renderLabels[objIndex].parentFamilyId = member.data.parentFamilyId;
        this.renderLabels[objIndex].childDisplayName = member.data.displayName;
      }
      else {
        this.renderLabels[objIndex].displayName = member.data.displayName;
        this.renderLabels[objIndex].firstName = member.data.firstName;
        this.renderLabels[objIndex].lastName = member.data.lastName;
        this.renderLabels[objIndex].gender = member.data.gender;
        this.renderLabels[objIndex].id = member.data.id;
        this.renderLabels[objIndex].profileImage = member.data.profileImage ?? "";
        this.renderLabels[objIndex].status = "active";
        this.renderLabels[objIndex].fatherId = member.data.fatherId;
        this.renderLabels[objIndex].motherId = member.data.motherId;
        this.renderLabels[objIndex].childId = member.data.childId;
        this.renderLabels[objIndex].spouseFamilyID = member.data.spouseFamilyId;
      }
    }
  }

  generateLabels() {
    this.fixedLabels = this.parentNodeService.parentlabelinfo;
    this.renderLabels = [...this.fixedLabels];
    try {
      if (this.pedegreeData.length > 0) {
        let data = this.getDesabledParentElements(this.pedegreeData);
        for (let i = 0; i < this.fixedLabels.length; i++) {
          let showElements = data.find(item => item.displayIndex === this.fixedLabels[i].displayIndex);
          if (showElements && this.renderLabels[i].displayIndex === this.fixedLabels[i].displayIndex) {
            this.renderLabels[i].profileImage = showElements.profileImage;
          }
          if (showElements) {
            if (!(undefined === (showElements.id)) && showElements.id > 0) {
              this.renderLabels[i] = { ...showElements, ...this.fixedLabels[i] };
              this.renderLabels[i].status = 'active';
            } else {
              this.renderLabels[i].status = 'disable';
              this.renderLabels[i].childId = showElements.childId;
              this.renderLabels[i].parentFamilyId = showElements.parentFamilyId;
              this.renderLabels[i].childDisplayName = showElements.childDisplayName;
              this.renderLabels[i].spouseFamilyId = showElements.spouseFamilyId;
            }
          }
          else {
            this.renderLabels[i].status = 'hide';
          }
        }
        this.showView = true;
      }
    } catch (error) {
      console.error('Tree editor backend data is empty' + error);
      throw error;
    }
  }

  getDesabledParentElements(pedegreeData: IndividualBaseViewModel[]): IndividualBaseViewModel[] {
    let individualBaseViewModelArray: any[] = [];
    for (let i = 0; i < pedegreeData.length; i++) {
      if (pedegreeData[i].fatherId === -1) {
        individualBaseViewModelArray.push({ "displayIndex": this.getDisplayIndex(pedegreeData[i].displayIndex, 0.0), "childId": pedegreeData[i].id, "spouseFamilyId": pedegreeData[i].parentFamilyId, "childDisplayName": pedegreeData[i].displayName });
      }

      if (pedegreeData[i].motherId === -1) {
        individualBaseViewModelArray.push({ "displayIndex": this.getDisplayIndex(pedegreeData[i].displayIndex, 0.1), "childId": pedegreeData[i].id, "spouseFamilyId": pedegreeData[i].parentFamilyId, "childDisplayName": pedegreeData[i].displayName });
      }
    }
    let arrayWithAll = [...pedegreeData, ...individualBaseViewModelArray]
    return arrayWithAll.sort(function (a, b) { return a.displayIndex - b.displayIndex; });
  }

  getDisplayIndex(childDisplayIndex, increment): Number {
    let divideby = 10;
    let newIndex = parseInt(childDisplayIndex) + 1 + (((((childDisplayIndex * 100) % 100) * 2) / 10) / divideby) + (increment / divideby);
    return Number(newIndex.toFixed(2));
  }

  toggleView() {
    this.switchToIpadView = !this.switchToIpadView;
    this.setTabView();
  }

  setTabView() {
    if (this.deviceWidth > this.tabDevicesWidthLimit) {
      this.isMobileDevice = false;
      if (this.switchToIpadView) {
        this.treeEditorXMove = (this.deviceWidth / 10) * 1.5;
        this.treeEditorYMove = 0;
        this.viewScale = 1; // Default size
      } else {
        this.setDefaultView();
      }
    } if (this.deviceWidth < this.tabDevicesWidthLimit && this.deviceWidth > this.mobileDevicesWidthLimit) {
      this.isMobileDevice = false;
      if (this.switchToIpadView) {
        this.treeEditorXMove = this.deviceWidth / 10 * 1.5;
        this.treeEditorYMove = this.deviceHeight / 10 * -1.6;
        this.viewScale = (this.defaultScale / 100) * 125; // Default size increased up to 125%
      } else {
        this.setDefaultView();
      }
    } if (this.deviceWidth < this.mobileDevicesWidthLimit) {
      this.isMobileDevice = true;
      if (this.switchToIpadView) {
        this.treeEditorXMove = this.deviceWidth / 10 * -0.5;
        this.treeEditorYMove = this.deviceHeight / (-2);
        this.viewScale = (this.defaultScale / 100) * 185; // Default size increased up to 185%
      } else {
        this.setDefaultView();
      }
    }
  }

  // This is the default treeEditor view
  setDefaultView() {
    this.treeEditorXMove = 0;
    this.treeEditorYMove = 0;
    this.viewScale = this.defaultScale;
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(ParentMessageType.ShowInformation, "not_implemented");
  }

  ngOnDestroy(): void {
    if(this.individualmanagementSubscription) {
      this.individualmanagementSubscription.unsubscribe();
    }
    if(this.pedigreeSubscription) {
      this.pedigreeSubscription.unsubscribe();
    }
    if(this.subscriptionRootMemberId) {
      this.subscriptionRootMemberId.unsubscribe();
    }
    if(this.treeEditorReloadSubscription) {
      this.treeEditorReloadSubscription.unsubscribe();
    }

    if(this.sessionDataSubcriber){
      this.sessionDataSubcriber.unsubscribe();
    }

    if (this.rootRectObserver) {
      this.rootRectObserver.disconnect();
    }
    window.removeEventListener('resize', this.updateRootRect);
    window.removeEventListener('scroll', this.updateRootRect, true);

    clearTimeout(this.highlightTimeoutId);
    clearTimeout(this.travelTimeoutId);
    clearTimeout(this.releaseTimeoutId);

    super.ngOnDestroy();
  }

  refreshTree(reload) {
    if (reload) {
      this.notifierService.updateEvent(NotifierEvents.RootMemberChanged, this.rootMember);
    }
  }
}
